/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button, Flex, Text } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';

import Icon from 'solis/claude/primitive/icon';
import ColonyIcon from 'solis/claude/element/colony.icon';


const OnClick = (event, dispatch, colonyID) =>
{
  dispatch.pushForeground({ route: Routes.Deploy.replace(':id', colonyID) });
};


export default ({ colony }) =>
{
  const dispatch = use(Navigation.Dispatch);

  const onClick = useCallback(OnClick, [ dispatch, colony.cass.id ]);

  return (
    <Button variant = 'soft' onClick = {onClick}>
      <Flex justify = 'between' align = 'center' width = '100%'>
        <Flex align = 'center' gap = '2'>
          <Icon size = '2'><ColonyIcon /></Icon>
          {colony.getName()}
        </Flex>
        <Text size = '1'>{colony.getZones().values().length + ' zones'}</Text>
      </Flex>
    </Button>
  );
};
